import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  viewBox: "0 0 65.6 68.5"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M63.2 36.6C63.2 52.8 50 66 33.8 66S4.4 52.8 4.4 36.6 17.6 7.2 33.8 7.2s29.4 13.2 29.4 29.4"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  d: "M51 35c0 9.5-7.7 17.2-17.2 17.2S16.6 44.5 16.6 35s7.7-17.2 17.2-17.2S51 25.5 51 35"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  d: "m33.9 55.4 10.7-7-.4-.7c-3 2.5-6.1 4.3-10.3 4.4z"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M45.1 30.2c-.2-5.1-4.6-9.1-9.7-8.8-1.3.1-2.6.4-3.8 1 5.5.5 10.4 3.4 13.5 7.8"
}, null, -1)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_6]))
}
export default { render: render }